// Id of the iframe that hosts support
export const supportPaneIFrameId: string = 'supportPaneIFrame';

// Id of the iframe that hosts feedback
export const feedbackPaneIFrameId: string = 'feedbackPaneIFrame';

// Id of the iframe that hosts get diagnostics
export const getDiagnosticsPaneIFrameId: string = 'getDiagnosticsPaneIFrame';

// App name for monarch
export const monarchAppName: string = 'Monarch';

// App name for OWA
export const owaAppName: string = 'Owa';

// Scenario name for support
export const supportScenarioName: string = 'InAppSupport';

// Origin for centro host for Get Diagnostics from feedback SDK
export const centroOrigin: string = 'https://admin.microsoft.com';

// ODS URL termplate for Support
export const odsSupportPaneUrlTemplate: string =
    'https://cjs.diagnostics.office.com/support/inappdiagnostics?';

// ODS URL template for Support (Test)
export const odsSupportPaneUrlTemplateTest: string =
    'https://cjs-test.diagnostics.office.com/support/inappdiagnostics?';

// Origin for ODS (Production)
export const odsOrigin: string = 'https://cjs.diagnostics.office.com';

// Origin for ODS (Test)
export const odsOriginTest: string = 'https://cjs-test.diagnostics.office.com';

// Enum for event types
export enum EventTypes {
    OnTokenRefreshed = 'OnTokenRefreshed',
    OnUserInfoAvailable = 'OnUserInfoAvailable',
    OnDonationDataAvailable = 'OnDonationDataAvailable',
    OnGetTracingCategories = 'OnGetTracingCategories',
    OnPerfTracingFinished = 'OnPerfTracingFinished',
    OnMetadataAvailable = 'OnMetadataAvailable',
    OnRecoveryActionComplete = 'OnRecoveryActionComplete',
    OnSupportErrorAvailable = 'OnSupportErrorAvailable',
    OnBootErrorInfoAvailable = 'OnBootErrorInfoAvailable',
    OnHostOriginAvailable = 'OnHostOriginAvailable',
    OnRecoveryActionListAvailable = 'OnRecoveryActionListAvailable',
}

// Local storage key for copilot service error
export const SupportErrorKey = 'SupportErrorKey';

// Local Cache Key for Active Support Ticket
export const activeSupportTicketKey = 'IsSupportTicketActive';

export const appIdMonarch = 2535;

export const appIdOwa = 2546;
